import React, { useState } from 'react';
import { ButtonMenuMovil } from './ButtonMenuMovil';
import { Logo } from './Logo';
import { MenuNavbar } from './MenuNavbar';
import { ButtonUserMenu } from './ButtonUserMenu';
import { ButtonNotifications } from './ButtonNotifications';
import { DrawerMenu } from './DrawerMenu';
import { DrawerProfileUser } from '../../pages/profile/drawerProfileUser/DrawerProfileUser';
import { useSelector } from 'react-redux';
import { usePresenceSocket } from '../../hooks/usePresenceSocket';
import { useNotificationsFeed } from '../../hooks/useNotificationsFeed';

export const Navbar = () => {
    const { user } = useSelector((state) => state.user);
    const { _id: userLoggedId } = user;

    usePresenceSocket();
    useNotificationsFeed();

    const [isOpenDrawerMenuMovil, setIsOpenDrawerMenuMovil] = useState(false);
    const [isOpenDrawerProfile, setIsOpenDrawerProfile] = useState(false);

    const toggleDrawerMenuMovil = () => {
        setIsOpenDrawerMenuMovil((prevState) => !prevState);
    }

    const toggleDrawerProfile = () => {
        setIsOpenDrawerProfile((prevState) => !prevState);
    }

    const handleOpenProfile = () => {
        setIsOpenDrawerProfile(true);
    }

    return (
        <>
            <nav className="bg-white fixed w-full z-10 shadow-sm shadow-indigo-950/10">
                <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-0">
                    <div className="flex h-20 items-center justify-between">
                        
                        <div className="flex w-[50%] md:w-[20%] md:ml-4">
                            <Logo/>
                        </div>
                        <div className='flex w-full justify-center bg-white'>
                            <MenuNavbar/>
                        </div>
                        <div className="hidden md:flex w-[20%] items-center justify-center gap-2">
                            {/* NOTIFICACIONES */}
                            <ButtonNotifications/>
                            {/* BUTTON USER MENU */}
                            <ButtonUserMenu/>
                        </div>
                        {/* MOBILE: NOTIFICACIONES + MENU BUTTON */}
                        <div className="flex md:hidden items-center gap-1">
                            <ButtonNotifications/>
                            <ButtonMenuMovil 
                                isOpen={isOpenDrawerMenuMovil}
                                toggleDrawer={toggleDrawerMenuMovil}
                            />
                        </div>                                
                    </div>
                </div>
            </nav>

            {/* DRAWER MENU MOBILE */}
            <DrawerMenu
                isOpenDrawerMenu={isOpenDrawerMenuMovil}
                toggleDrawerFilters={toggleDrawerMenuMovil}
                onOpenProfile={handleOpenProfile}
            />

            {/* DRAWER PROFILE USER - Para cuando se abre desde el menú móvil */}
            <DrawerProfileUser
                isOpenDrawerProfile={isOpenDrawerProfile}
                toggleDrawerProfile={toggleDrawerProfile}
                userId={userLoggedId}
                refreshTable={false}
            />
        </>
    )
}
